import React from 'react';
import { IonPage, IonContent } from '@ionic/react';

import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

import HeroSection from './HeroSection';
import SectionAbout from './SectionAbout';
import SectionServices from './SectionServices';
import SectionWork from './SectionWork';
import SectionWhy from './SectionWhy';
import SectionProcess from './SectionProcess';
import CTASection from '@/components/CTASection';

const Home: React.FC = () => {
  return (
    <IonPage id="home-page">
      <IonContent fullscreen scrollY scrollEvents={true}>
        <div className="page-wrapper">
          <Navbar />
          
          <HeroSection />
          <SectionAbout />
          <SectionServices />
          <SectionWork />
          <SectionWhy />
          <SectionProcess />
          <CTASection />

          <Footer />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Home;
